import Vue from 'vue'
import Router from 'vue-router'
import { LoginCallback } from '@okta/okta-vue'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(console.warn)
}

Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(console.warn)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      // handles OAuth callback
      path: '/login/callback',
      component: LoginCallback
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/pages/Signup')
    },
    {
      path: '/:buildingId?',
      name: 'default',
      component: () => import('@/pages/Default'),
      meta: {
        // https://github.com/okta/okta-vue/tree/okta-vue-3.0.0#add-a-protected-route
        requiresAuth: true
      }
    },
    {
      path: '/tour-ring/:buildingId',
      name: 'tour-ring',
      component: () => import('@/pages/TourRing'),
      meta: {
        // https://github.com/okta/okta-vue/tree/okta-vue-3.0.0#add-a-protected-route
        requiresAuth: true
      }
    },
    {
      path: '/conference/:buildingId',
      name: 'conference',
      component: () => import('@/pages/Conference'),
      meta: {
        // https://github.com/okta/okta-vue/tree/okta-vue-3.0.0#add-a-protected-route
        requiresAuth: true
      }
    }
  ]
})

export default router
